import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, DoCheck, ViewChild } from '@angular/core';
import { Report } from 'src/app/reports/components/report/models/report.model';
import { QueryDetailComponent } from './query-detail/query-detail.component';

@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss']
})
export class QueryComponent implements OnInit, DoCheck {

  //#region Inputs

  @Input() report: Report;
  @Input() disabled = false;
  @ViewChild('query') query: QueryDetailComponent;
  @ViewChild('queryDetail') queryDetail: QueryDetailComponent;

  @Output() onUpdateQuery: EventEmitter<any> = new EventEmitter<any>();

  //#endregion

  //#region Ctor

  constructor() { }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
  }

  ngDoCheck() {
  }

  //#endregion

  updateQuery() {
    this.onUpdateQuery.emit();
  }
}
